module.exports = __webpack_public_path__ + "img/img18_1.11990286.svg";